import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist'
import {
    ActionHistoryTableSortProps,
    ActionHistoryTableSearchProps
} from './action-history-table-base.types'

export const initialActionHistoryTablePaginationProps: PaginationProps<ActionHistoryTableSortProps> = {
    page: 0,
    size: window.innerWidth >= 1920 ? 10 : 6,
    sortDirection: SortDirection.ASC,
    sortProp: ActionHistoryTableSortProps.TIME,
    totalElements: 0,
    totalPages: 0
}

export const initialActionHistoryTableSearchProps: ActionHistoryTableSearchProps = {
    actionType: null,
    changes: null,
    entityTitle: null,
    periodFrom: null,
    periodTo: null,
    userFullname: null
}

export const ordersNeedTimeoutProps: Array<keyof ActionHistoryTableSearchProps> = [
    "actionType"
]
